import React, { useEffect, useState } from 'react';

interface PWAInstallPromptProps {
  onInstall: () => void;
  onDismiss: () => void;
}

export const PWAInstallPrompt: React.FC<PWAInstallPromptProps> = ({ onInstall, onDismiss }) => {
  const [deferredPrompt, setDeferredPrompt] = useState<any>(null);

  useEffect(() => {
    const handler = (e: any) => {
      // Prevent the mini-infobar from appearing on mobile
      e.preventDefault();
      // Stash the event so it can be triggered later.
      setDeferredPrompt(e);
    };

    window.addEventListener('beforeinstallprompt', handler);

    return () => {
      window.removeEventListener('beforeinstallprompt', handler);
    };
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt) {
        // Fallback or instructions if prompt is not available
        alert("Para instalar, use a opção 'Adicionar à Tela de Início' do seu navegador.");
        onInstall();
        return;
    }

    // Show the install prompt
    deferredPrompt.prompt();

    // Wait for the user to respond to the prompt
    const { outcome } = await deferredPrompt.userChoice;
    console.log(`User response to the install prompt: ${outcome}`);
    
    // We've used the prompt, and can't use it again, discard it
    setDeferredPrompt(null);
    onInstall();
  };

  return (
    <div className="w-full animate-fade-in text-center flex flex-col items-center">
      <div className="w-24 h-24 bg-white/10 rounded-3xl mb-6 flex items-center justify-center p-4 backdrop-blur-md shadow-2xl border border-white/20">
         {/* Using the logo as requested */}
         <img src="/logo.png" alt="NossaPesca Logo" className="w-full h-full object-contain drop-shadow-md" />
      </div>

      <h2 className="text-2xl font-display font-bold mb-2">Instale o App Oficial</h2>
      <p className="text-white/60 text-sm mb-8 max-w-xs mx-auto leading-relaxed">
        Tenha a melhor experiência, receba notificações e acesse offline.
      </p>

      <div className="w-full space-y-3">
        <button
          onClick={handleInstallClick}
          className="w-full py-4 rounded-xl font-bold text-lg bg-white text-blue-900 shadow-lg transition-transform active:scale-95 flex items-center justify-center gap-2"
        >
          <span className="material-symbols-outlined">download</span>
          Instalar Agora
        </button>
        
        <button
          onClick={onDismiss}
          className="w-full py-3 rounded-xl font-medium text-white/40 hover:text-white transition-colors"
        >
          Agora não
        </button>
      </div>
    </div>
  );
};
